import type { ProductVariant } from '@az/middleware/src/__generated__/gql/graphql';

function getVariantByAttributes(products: ProductVariant[], attributes: Record<string, any>) {
  if (!products || products.length === 0) {
    return null;
  }
  const configurationKeys = Object.keys(attributes);

  return products.find((product) => {
    const currentAttributes = product.attributesRaw.map((attr) => {
      const value = attr?.value.key ?? attr?.value;
      return {
        name: attr.name,
        value,
      };
    });

    return configurationKeys.every((attrName) =>
      currentAttributes.find(({ name, value }) => attrName === name && attributes[attrName] === value),
    );
  });
}

export function filterProducts(
  products: ProductVariant[],
  filters: { master?: boolean; skus?: string[]; attributes?: Record<string, any> } = {},
) {
  if (!products) {
    return [];
  }
  if (filters.skus) {
    return products.filter((product) => filters.skus.includes(product.sku));
  }
  if (filters.attributes && Object.keys(filters.attributes).length > 0) {
    return [getVariantByAttributes(products, filters.attributes)];
  }
  if (filters.master) {
    return products.filter((product) => product._master);
  }
  return products;
}
